import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import { IManifestChargeFilter } from '../components/FilterComponent/ManifestChargeFilterComponent';
import { ICustomerComplaintFilter, IDailyActivityFilter, IDeliverySLRReportFilter, IFilter, IFuelFilterParams, IVehicleTrackingReportFilter } from './../model/CommonModel';
import AjexPortalService from "./api";
import config from './config';
import { IManifestApprovalFilter } from '../components/FilterComponent/IRSManifestApprovalReport';
import { ICodFodFilter } from '../components/FilterComponent/FodCodReportFilterComponent';


const operation = config.get('operation');
const download = config.get('download');
const booking = config.get('booking');
const dateFilter = config.get('dateFilter');
const employee = config.get('employee');
const notDelivery = config.get('notDelivery');
const rtoRequest = config.get('rtoRequest');
const vehicle = config.get('vehicle');
const tripPlan = config.get('tripPlan');
const report = config.get('report');
const customerFinance = config.get('customerFinance');
const manifestFailDownload = config.get('manifestFailDownload');
const manifest = config.get('manifest');
const manifestChargeReport = config.get('manifestChargeReport');
const tripWaybillReport = config.get('tripWaybillReport');
const customer = config.get('customer');
const customerReport = config.get('customerReport');
const deliverysheet = config.get('deliverysheet');
const deliverySheetReport = config.get('deliverySheetReport');
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;
const reportURLV2 = process.env.REACT_APP_TMS_REPORT_SERVICE_V2;
const commonURL = process.env.REACT_APP_TMS_COMMON_SERVICE
const email = config.get('email');
const manifestReport = config.get('manifestReport');
const locateShipment = config.get('locateShipment');
const cashCollectionReport = config.get('cashCollectionReport');
const wbWiseFleetDetails = config.get('wbWiseFleetDetails');
const podAvailabilityReport = config.get('podAvailabilityReport');
const exemption = config.get('exemption');
const pfnReport = config.get('pfnReport');
const marken = config.get('marken');
const dailyActivityReport = config.get('dailyActivityReport');
const markenKpiReport = config.get('markenKpiReport');
const markenClientReport = config.get('markenClientReport');
const markenGeneralReport = config.get('markenGeneralReport');
const kpiReport = config.get('kpiReport');
const pickedUpNotDeliveredWaybillsReport = config.get('pickedUpNotDeliveredWaybillsReport');
const waybillsNotInvoicedReport = config.get('waybillsNotInvoicedReport');
const customerComplaint = config.get('customerComplaint');
const missPickUpReport = config.get('missPickUpReport');
const vehicleTrackingReport = config.get('vehicleTrackingReport');
const geofencingURL = process.env.REACT_APP_TMS_GEOFENCING_SERVICE;

export const DownloadBookingReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService.post(`${reportURLV2}${booking}/${download}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadOperationReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService.post(`${reportURL}/${operation}/${download}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadEmployeeReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${employee}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadFODCODReportService = async (data: ICodFodFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/fod-cod-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadPodBarcodeReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/pod-barcode-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadLocateShipmentReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${locateShipment}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadCashCollectionReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${cashCollectionReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadNotDeliveryReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${notDelivery}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadRTOReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${rtoRequest}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadTripPlanReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${tripPlan}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadVehicleReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${vehicle}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadFinanceManifestReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${customerFinance}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadNotManifestedReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${commonURL}/${manifest}/${manifestFailDownload}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadManifestChargeReportService = async (data: IManifestChargeFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${manifestChargeReport}/${download}/${dateFilter}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadIRSManifestApprovalReportService = async (data: IManifestApprovalFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/download/manifest-approval-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadTripplanWaybillReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${tripPlan}/${download}/${tripWaybillReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadCustomerReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${customer}/${customerReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadDeliverySheetReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${deliverysheet}/${deliverySheetReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const EmailManifestReportService = async () => {
    try {
        //https://apps.aj-ex.com/tms-report-service/api/v1/email/manifest-report
        return await AjexPortalService.post(`${reportURL}/${email}/${manifestReport}`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const EmailManifestReportV2Service = async () => {
    try {
        //https://apps.aj-ex.com/tms-report-service/api/v1/email/manifest-report
        return await AjexPortalService.post(`${reportURLV2}report/manifest-report`)
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const DownloadWbWiseFleetDetaisReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${wbWiseFleetDetails}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadPodAvailabilityReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${podAvailabilityReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadExemptionReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${notDelivery}/${download}/${exemption}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadPfnReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${pfnReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadCustomerInfoReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${customer}/${customerReport}/${download}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadMarkenReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${marken}/${download}/${markenGeneralReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadMarkenClientReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${marken}/${download}/${markenClientReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadMarkenKPIReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${marken}/${download}/${markenKpiReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}
export const DownloadDailyActivityService = async (data: IDailyActivityFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${dailyActivityReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadDeliverySLRReportService = async (data: IDeliverySLRReportFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/delivery-slr-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadDeliverySLRDetailsService = async (data: IDeliverySLRReportFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/delivery-slr-details-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadMissPickUpReportService = async (data: IDeliverySLRReportFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${missPickUpReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadWaybillsNotDeliveredReportService = async (data: IDailyActivityFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${pickedUpNotDeliveredWaybillsReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const DownloadWaybillsNotInvoicedReportService = async (data: IDailyActivityFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${waybillsNotInvoicedReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const DownloadComplaintReportService = async (data: ICustomerComplaintFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${customerComplaint}/${download}/${report}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const DownloadComplaintKpiReportService = async (data: ICustomerComplaintFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${customerComplaint}/${download}/${kpiReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const DownloadPerformanceScanReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/scan-performance-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadVehicleTrackingReportService = async (data: IVehicleTrackingReportFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/${vehicleTrackingReport}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const DownloadIRSShipmentReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/${download}/irs-shipment-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const DownloadFuelReportService = async (filterParams?: IFuelFilterParams) => {
    const { vehicleId, driverId, cityId, startDate, endDate } = filterParams || {};
    try {
        return await AjexPortalService.get(`${reportURL}/${report}/vehicle-fuel/to-excel?vehicleId=${vehicleId ?? ""}&driverId=${driverId ?? ""}&cityId=${cityId ?? ""}&startDate=${startDate ?? ""}&endDate=${endDate ?? ""}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const DownloadExceptionReportService = async (params) => {
    // const { vehicleId, driverId, cityId, startDate, endDate } = filterParams || {};
    try {

        const queryParams = new URLSearchParams();

        const paramsMap = {
            type: params?.type,
            startDate: params?.startDate,
            endDate: params?.endDate,
            orgCityId: params?.originCityId,
            destCityId: params?.destCityId,
            exceptionIds: params?.exceptionIds,
            waybillNo: params?.waybillNo,
            approveStatus: params?.approveStatus
        };

        Object.entries(paramsMap).forEach(([key, value]) => {
            if (value) {
                queryParams.append(key, value.toString());
            }
        });

        return await AjexPortalService.get(`${reportURL}/${report}/download/exception-report?${queryParams.toString()}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const DownloadFinanceManifestWithVehiclesReportService = async (data: IFilter) => {
    try {
        return await AjexPortalService.post(
            `${reportURL}/${report}/customer-finance-with-vehicles`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};

export const FetchOccVehicleTrackingHistoryService = async (data: { id: string; fromDate: string; toDate: string; role?: string }) => {
    try {
        const occUrl = process.env.REACT_APP_TMS_OCC_SERVICE;
        return await AjexPortalService.post(`${occUrl}occ/vehicle-tracking-history`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
}

export const GetGeofenceSummaryService = async (params: {
    vehiclePlateNumber?: string;
    fromDate?: string | Date;
    toDate?: string | Date;
    stationId?: number;
    eventType?: string;
    divisionIds?: number[];
}) => {
    try {
        const fmtDate = (d?: string | Date) =>
            d instanceof Date ? d.toISOString().slice(0, 10) : d;

        const queryParams = new URLSearchParams();

        if (params.vehiclePlateNumber) queryParams.append('vehiclePlateNumber', params.vehiclePlateNumber);
        const from = fmtDate(params.fromDate);
        if (from) queryParams.append('fromDate', from);
        const to = fmtDate(params.toDate);
        if (to) queryParams.append('toDate', to);
        if (params.stationId !== undefined) queryParams.append('stationIds', String(params.stationId));
        if (params.eventType) queryParams.append('eventType', params.eventType);
        if (params.divisionIds && params.divisionIds.length) {
            queryParams.append("divisionIds", `${params.divisionIds.join(",")}`);
        }

        return await AjexPortalService.get(`${geofencingURL}geo-fencing/geofence-summary?${queryParams.toString()}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const FetchGeoHistoryService = async (params: {
    fromTime?: string;
    toTime?: string;
    vehiclePlateNumber?: string;
    eventId?: string;
}) => {
    try {

        const queryParams = new URLSearchParams();

        if (params?.fromTime) queryParams.append("fromTime", params.fromTime);
        if (params?.toTime) queryParams.append("toTime", params.toTime);
        if (params?.vehiclePlateNumber) queryParams.append("vehiclePlateNumber", params.vehiclePlateNumber);
        if (params?.eventId) queryParams.append("eventId", params.eventId);

        const finalURL = `${geofencingURL}geo-fencing/history?${queryParams.toString()}`;
        console.log(finalURL);

        return await AjexPortalService.get(finalURL);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const DownloadFFDBookingReportService = async (data) => {
    try {
        return await AjexPortalService
            .post(`${reportURL}/${report}/download/ffd-booking-report`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}